"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikDropdownMulti = void 0;
const react_1 = __importStar(require("react"));
const dropdown_1 = require("../../components/dropdown");
const useFieldValidation_1 = require("../../hooks/useFieldValidation");
const ValidationDropdownMulti = (0, useFieldValidation_1.ValidationComponent)(dropdown_1.DropdownMulti);
function FormikDropdownMulti(args) {
    const { children, onFocus, onBlur, onChange } = args, props = __rest(args, ["children", "onFocus", "onBlur", "onChange"]);
    const { field, status, info, helpers } = (0, useFieldValidation_1.useFieldValidation)(props);
    const { value: selected } = field;
    const childrenArr = react_1.Children.toArray(children);
    const options = childrenArr.map((element, i) => {
        const { value } = element.props;
        return (0, react_1.cloneElement)(element, {
            key: i,
            selected: !!selected && !!~selected.indexOf(value),
        });
    });
    return (react_1.default.createElement(ValidationDropdownMulti, Object.assign({}, props, { info: info, status: status, onFocus: (e) => {
            helpers.setTouched(false);
            onFocus && onFocus(e);
        }, onChange: (value) => {
            helpers.setTouched(true);
            helpers.setValue(value);
            onChange && onChange(value);
        }, onBlur: (e) => {
            var _a;
            if ((_a = e.target.parentElement) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget))
                helpers.setTouched(false);
            else
                helpers.setTouched(true);
            onBlur && onBlur(e);
        } }), options));
}
exports.FormikDropdownMulti = FormikDropdownMulti;
//# sourceMappingURL=multiple.js.map